import { doc, increment, setDoc } from "firebase/firestore";
import { db } from "../lib/firebase";

export function logProductView(productId) {
  if (!productId) return;
  const ref = doc(db, "analytics", String(productId));
  setDoc(ref, { productId: String(productId), views: increment(1) }, { merge: true }).catch(
    () => {},
  );
}

export function logAddToCart(productId) {
  if (!productId) return;
  const ref = doc(db, "analytics", String(productId));
  setDoc(
    ref,
    { productId: String(productId), addToCarts: increment(1) },
    { merge: true },
  ).catch(() => {});
}
